module.exports = __webpack_public_path__ + "assets/CorrectParrot.fc6cbe26.svg";